// extracted by mini-css-extract-plugin
export default {"loading":"Wireless_loading__7U9Wt","wirelessMaxCountInfo":"Wireless_wirelessMaxCountInfo__ZncV8"};